import { Link } from "react-router-dom";
import useSWR from "swr";
import { Coffee, Heart } from "lucide-react";
import { listSupporters } from "@/lib/api";
import useTipper from "@/hooks/use-tipper";

export const TipPrompt = () => {
  const tipper = useTipper();
  const { data } = useSWR("/supporters", listSupporters);
  const count = data?.total || 0;

  return (
    <div
      data-testid="tip-prompt"
      className="rounded-2xl border border-[#d95d39]/30 bg-[#d95d39]/[0.06] p-5 flex flex-wrap items-center justify-between gap-4"
    >
      <div className="flex items-center gap-3 min-w-0">
        <Coffee className="w-5 h-5 text-[#d95d39] flex-shrink-0" />
        <div>
          <div className="font-serif-editorial text-xl text-[#f4f1ea]">
            {tipper ? "Thanks for backing the vault." : "Enjoyed this? Buy me a coffee."}
          </div>
          <Link
            to="/support#supporter-wall"
            data-testid="tip-prompt-wall-link"
            className="text-sm text-white/55 hover:text-[#d95d39] transition-colors"
          >
            {count > 0
              ? `Join ${count} ${count === 1 ? "supporter" : "supporters"} on the wall →`
              : "Be the first name on the supporter wall →"}
          </Link>
        </div>
      </div>
      {!tipper && (
        <a
          href="https://paypal.me/tobiasdeamon/3EUR"
          target="_blank"
          rel="noreferrer"
          data-testid="tip-prompt-paypal-btn"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#d95d39] hover:bg-[#c14e2e] text-white font-mono-tech text-[11px] uppercase tracking-[0.22em] transition-colors"
        >
          <Heart className="w-4 h-4" /> Tip €3
        </a>
      )}
    </div>
  );
};
